export enum Routes {
  App = '/',
  Login = '/login',
  SettingsSegmentConfig = '/settings/segment-config',
  Receipt = '/receipt',
  ReceiptChooseSegmentStatus = '/receipt/choose-segment-status',
  ReceiptSuccess = '/receipt/success',
  ReceiptRepair = '/receipt/repair',
  ReceiptRepairPending = '/receipt/repair-pending',
  Tunnel = '/tunnel',
  TunnelRingComplete = '/tunnel/complete',

  SessionInfo = '/session',
}
